/* lua.js generated code 0.3.0 */

memory_class = function () {
    var class_type = table()
    class_type.new = function () {
        var __VA_ARG = $slice(arguments, 0)
        var [obj, _t] = [table(), table()]
        setmetatable(obj, table([1, "__index", function (table, key) {
                if (key === "decryptionFunc" || key === "encryptionFunc") {
                    return class_type[key]
                }
                var decryptionFunc = table.decryptionFunc
                var result = null
                if (decryptionFunc != null) {
                    result = decryptionFunc(table, key)
                }
                if (result == null) {
                    result = _t[key]
                } //1st: get data from self.
                if (result == null) {
                    result = class_type[key]
                } //then find in class def
                //if type(result) ~= "function" then print("__index::", tostring(key)) end
                return result
            }], [1, "__newindex", function (table, key, value) {
                if (type(value) !== "function") {
                    //print("access __newindex:", key, value)
                    var encryptionFunc = table.encryptionFunc
                    var succeed = false
                    if (encryptionFunc != null) {
                        succeed = encryptionFunc(table, key, value)
                    }
                    if (false === succeed) {
                        _t[key] = value
                    }
                } else {
                    _t[key] = value
                }
            }]))
        if (obj.ctor) {
            obj.ctor(...__VA_ARG)
        }
        return obj
    }
    return class_type
}
var kFastEncryptInteger = table()
encrypt_integer_f = function (k, v) {
    //print("encrypt_integer_fast:", k, v)
    if (v == null) {
        v = 0
    }
    var encrypted = -(v * 3 + 2)
    kFastEncryptInteger[k] = encrypted
}
decrypt_integer_f = function (k) {
    var encrypted = kFastEncryptInteger[k] || 0
    return (-encrypted - 2) / 3
}
//直接读取加密状态下的值
mem_readByKey = function (k) {
    return kFastEncryptInteger[k]
}

mem_deleteByKey = function (key) {
    kFastEncryptInteger[key] = null
}
let encryptInteger = {}
encrypt_integer = function (k, v) {
    //print("he.HeMemDataHolder::encrypt_integer", k, v)
    if (v == null) {
        v = 0
    }
    encryptInteger[k] = v
}
let encryptNumber = {}
encrypt_number = function (k, v) {
    //print("he.HeMemDataHolder::encrypt_number", k, v)
    if (v == null) {
        v = 0
    }
    encryptNumber[k] = v
}
let encryptString = {}
encrypt_string = function (k, v) {
    //print("he.HeMemDataHolder::encrypt_string", k, v)
    if (v == null) {
        v = ""
    }
    encryptString[k] = v
}
decrypt_integer = function (k) {
    return tonumber(encryptInteger[k])
}
decrypt_number = function (k) {
    return tonumber(encryptNumber[k])
}
decrypt_string = function (k) {
    return encryptString[k]
}
